function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmartId = function SvgSmartId(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 186.2 24.9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AFAA"
    },
    d: "M0.1,17.1h4.4c0.3,2.5,1.3,4.6,5.5,4.6c2.7,0,4.7-1.5,4.7-3.8c0-2.3-1.1-3.1-5.2-3.8c-5.9-0.8-8.8-2.6-8.8-7.2 c0-4,3.5-7.1,8.6-7.1c5.3,0,8.5,2.4,9,7.2h-4.2c-0.5-2.6-1.9-3.7-4.8-3.7c-2.8,0-4.3,1.3-4.3,3.2c0,2,0.8,3,5.1,3.6 c5.8,0.8,8.9,2.5,8.9,7.4c0,4.3-3.6,7.6-9.1,7.6C3.3,25.1,0.5,21.8,0.1,17.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00AFAA"
    },
    points: "27.9,0.1 34.1,0.1 40.6,16.9 47,0.1 53.1,0.1 53.1,24.8 48.5,24.8 48.5,6.1 41.1,24.8 39.6,24.8 32,6.1 32,24.8 27.9,24.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00AFAA"
    },
    points: "122.9,3.7 116,3.7 116,0.1 134.5,0.1 134.5,3.7 127.6,3.7 127.6,24.8 122.9,24.8 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.4,
    y: 11.7,
    style: {
      fill: "#00AFAA"
    },
    width: 9.3,
    height: 3.6
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00AFAA"
    },
    points: "83.6,24.8 75.4,0.1 69.3,0.1 61,24.8 65.4,24.8 72.1,3.8 75.5,14.5 72.5,14.5 71.4,18.1 76.6,18.1 78.8,24.8 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 0.1,
    style: {
      fill: "#00AFAA"
    },
    width: 4.7,
    height: 24.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AFAA"
    },
    d: "M173.2,0.1h-7.5v24.7h4.6l0-3.6V3.7h2.7c5.8,0,8.3,3.2,8.3,8.5v0.3c0,4.6-1.9,7.6-5.8,8.4v3.8 c7.2-0.8,10.7-5.6,10.7-12.2v-0.3C186.1,5,181.9,0.1,173.2,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AFAA"
    },
    d: "M103.6,14.1c3.1-0.8,5.5-2.8,5.5-6.6V7.3c0-5-3.8-7.3-9.3-7.3h-8.3v24.7h4.6V3.6h3.7c3,0,4.7,1,4.7,3.8v0.1 c0,2.6-1.6,3.9-4.7,3.9h-0.8v3.3l6.5,10h5L103.6,14.1z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmartId, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smart_id.2fab8478.svg";
export { ForwardRef as ReactComponent };